import React from 'react';
import { Box, Typography } from '@mui/material';

export default function PageContainer({ title, children }) {
  return (
    <Box sx={{ p: 2, maxWidth: 720, mx: 'auto' }}>
      {title ? (
        <Typography variant="h5" component="h1" gutterBottom>
          {title}
        </Typography>
      ) : null}
      {children}
    </Box>
  );
}
